import { fetchListIncreaseBalance } from "@/api/merchant/request.get";
import { numberSeparator, toPersianNumber } from "@/hooks/useThousandsSeparator";
import CustomTable from "@/shared/components/common/table";
import StackKit from "@/shared/components/kit/stack";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import { useQuery } from "@tanstack/react-query";
import moment from "jalali-moment";
/**
 * ContentTransactions
 *
 * این کامپوننت جهت نمایش لیست تراکنش‌های انجام‌شده برای افزایش موجودی هدیه طراحی شده است.
 * داده‌ها شامل مبلغ شارژ، تاریخ تراکنش، مبلغ واریزی به پولی پی، نوع واریز، موجودی پس از شارژ
 * و توضیحات مربوطه می‌باشد.
 *
 * این بخش:
 * - اطلاعات تراکنش‌ها را از API دریافت می‌کند.
 * - مقادیر عددی را با جداکننده هزارگان نمایش می‌دهد.
 * - تاریخ‌ها را به فرمت جلالی تبدیل کرده و نمایش می‌دهد.
 * - جدول تراکنش‌ها را به صورت کاملاً ساختاریافته ارائه می‌کند.
 *
 * @param listIncreaseGift آرایه‌ای از اطلاعات تراکنش‌های انجام‌شده جهت افزایش موجودی هدیه
 *
 * @returns JSX.Element
 */

const ContentTransactions = ({ listIncreaseGift }: { listIncreaseGift: any }) => {
  const {data: dataListIncreaseBalance,isFetched,isLoading,} = useQuery({
    queryKey: ["ListPazirandeClubsContentTransactions-data"],
    queryFn: fetchListIncreaseBalance,
  });
  const dataHeader = [
    { id: "r", title: "ردیف" },
    { id: "price", title: "مبلغ شارژ( ریال)" },
    { id: "created_at", title: "تاریخ شارژ" },
    { id: "price_deposit_20card", title: `مبلغ واریز به پولی پی` },
    { id: "type", title: "نوع واریز" },
    { id: "balance_after_increase", title: "موجودی پس از شارژ" },
    { id: "description", title: "توضیحات" },
  ];

  const dataNew = listIncreaseGift?.map((item: any, index: number) => {
    return {
      ...item,
      r: <StackKit><TypoGraphyKit variant="body1">{toPersianNumber(index + 1)}</TypoGraphyKit></StackKit>,
      price: <StackKit><TypoGraphyKit variant="body1">{numberSeparator(item.price)}</TypoGraphyKit></StackKit>,
      created_at: <StackKit><TypoGraphyKit variant="body1">{toPersianNumber(moment(item?.created_at).locale("fa").format("YYYY/MM/DD"))}</TypoGraphyKit></StackKit>,
      price_deposit_20card: <StackKit><TypoGraphyKit variant="body1">{numberSeparator(item.price_deposit_20card)}</TypoGraphyKit></StackKit>,
      type: <StackKit><TypoGraphyKit variant="body1">{item.type === "deposit" ? "برداشت از کیف پول" : "درگاه بانکی"}</TypoGraphyKit></StackKit>,
      balance_after_increase: <StackKit><TypoGraphyKit variant="body1">{numberSeparator(item.balance_after_increase)}</TypoGraphyKit></StackKit>,
      description: item.description ? <StackKit alignItems={"center"}><TypoGraphyKit variant="body1">{item.description}</TypoGraphyKit></StackKit>
        : <StackKit alignItems={"center"} justifyContent={"center"}><TypoGraphyKit variant="body1" sx={{ textAlign: "center" }}>-</TypoGraphyKit></StackKit>,

    };
  });


  const fakeData = dataNew
  return (
    <StackKit alignItems={"start"} sx={{ width: "100%" }}>
      <TypoGraphyKit variant="h6">تراکنش های افزایش موجودی هدیه</TypoGraphyKit>
      <CustomTable dataHeader={dataHeader} dataTbody={fakeData} />
    </StackKit>
  );
};

export default ContentTransactions;